Jelly.Actions.Execute_By_Namespace = function(Parameters)
{		
	// Populates action parameters for a namespace, and calls jelly.actions.execute with the parameters	
	var Debug = false && Jelly.Debug.Debug_Mode;

	if (Debug)
	{
		Jelly.Debug.Group("Execute_By_Namespace");
		Jelly.Debug.Log(Parameters);
	}
	
	// Initialize common values...

	// Get action namespace
	var Action_Namespace = Parameters["Namespace"];

	// Get action element
	var Action_Element = document.getElementById(Action_Namespace);

	// Get action reference
	var Action_Reference = Jelly.References.Get_Reference_For_Element(Action_Element);

	// Don't execute if upload in progress
	if (Object.keys(Action_Reference.Uploads_In_Progress).length) {
		// Display the error.
		Jelly.Actions.Show_Result({
			Namespace: Action_Namespace,
			Content: "Please wait for upload to complete first, then press submit again"
		});
	}

	// Don't execute if mid executing
	else if (!$('#' + Action_Namespace + ' .Jelly_Action_Execute').hasClass('Executing')) {
		async.series([
			// Hide results...
			function (Return)
			{
				// Hide result elements.
				Jelly.Actions.Hide_Results({Namespace: Action_Namespace});
							
				// Disable action execution
				Jelly.jQuery('#' + Action_Namespace + ' .Jelly_Action_Execute').addClass('Executing');
				
				// Show loading indicator
				Jelly.Interface.Show_Loading_Indicator(Action_Reference);
		
				Return();
			},
		
			// Perform client-side validations for action....
			function (Return) 
			{
				// Perform validations 
				Jelly.Actions.Validate({"Namespace": Action_Namespace, "Return": Return});
			},

			// Execute action...
			function (Return) 
			{	
				// Get action type
				var Action_Type = Action_Reference["Type_Alias"];

				// Get action values
				var Action_Safe_Values = Jelly.References.Get_Input_Values_For_Action(
						{
							"Namespace": Action_Namespace,
							"Include_Sensitive": false
						}
					);
		
				// Instantiate action execute parameters
				var Action_Execute_Parameters = {};	

				// Set action parameters namespace
				Action_Execute_Parameters["Namespace"] = Action_Namespace;

				// Set action calling element 
				// TODO - should we just start doing these by reference, or are there times that we need just an element w/ no reference? 
				Action_Execute_Parameters["Calling_Element"] = Action_Element;

				// Set action values
				Action_Execute_Parameters["Values"] = Action_Safe_Values;

				// Optional lifecycle callbacks are used by redirect-based actions
				// which must wait for this exact request, rather than any global
				// jQuery AJAX completion.
				Action_Execute_Parameters["On_Success"] = Parameters["On_Success"];
				Action_Execute_Parameters["On_Failure"] = Parameters["On_Failure"];
				Action_Execute_Parameters["On_Request"] = Parameters["On_Request"];
				Action_Execute_Parameters["Should_Ignore_Completion"] = Parameters["Should_Ignore_Completion"];

				// Copy action alias from reference
				Action_Execute_Parameters['Action'] = Action_Reference["Alias"];
				
				// Copy action id 
				Action_Execute_Parameters['Action_ID'] = Action_Reference["ID"];

				// Set action type
				Action_Execute_Parameters["Action_Type"] = Action_Type;

				// If this is a type action, copy the target information from the parameters
				if (Action_Type == "Type_Action")
				{
					// TODO - verify existence
					Action_Execute_Parameters['Target'] = Parameters['Target'];
					Action_Execute_Parameters['Target_Type'] = Parameters['Target_Type'];
				}

				// Execute this action.
				// TODO - perhaps Return can be integrated into execution later.
				Jelly.Actions.Execute(Action_Execute_Parameters);
				
				Return();
			}],
			
			// Debugging 
			function (err, results)
			{	
				if (Debug)
				{
					Jelly.Debug.Log(err);
					Jelly.Debug.Log(results);
					Jelly.Debug.End_Group("Execute_By_Namespace");				
				}
			}
			
		);
	}
};
